import * as actions from 'redux/actions/keywords.actions'

import updateKeyword from './updateKeyword'

const updateKeywords = (keywords, { type, payload = {} }) => {
  let updatedKeywords = {
    ...keywords
  }
  switch (type) {
    case actions.getKeywordSerpSuccess.type:
    case actions.getKeywordHistorySuccess.type:
      updatedKeywords[payload.keywordId] = updateKeyword(updatedKeywords[payload.keywordId], {
        type,
        payload
      })
      return updatedKeywords
    default:
      return updatedKeywords
  }
}

export default updateKeywords
